import { render, staticRenderFns } from "./tb.vue?vue&type=template&id=5aa21624&"
import script from "./tb.vue?vue&type=script&lang=js&"
export * from "./tb.vue?vue&type=script&lang=js&"
import style0 from "./tb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports